import { AbsoluteCenter, Center, useTheme } from '@chakra-ui/react';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import StickyHeader from '../../components/StickyHeader';
import RegularSolidButton from '../../components/buttons/RegularSolidButton';
import { ReactComponent as CloseIcon } from '../../icons/xmark.svg';
import { Xmark } from '@peacecover/icon';

const Title = styled.div`
  font-size: 26px;
  font-weight: 700;
  line-height: 31px;
  text-align: center;
`;

const Description = styled.div`
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  padding-top: 14px;
`;

const BalloonMessage = styled.div`
  width: fit-content;
  background-color: rgba(0, 178, 255, 1);
  border-radius: 12px;
  padding: 7px 14px;
  text-align: center;
  position: relative;
  margin-bottom: 18px;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  animation: float 1.5s ease-in-out infinite;

  @keyframes float {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-3px);
    }
    100% {
      transform: translateY(0px);
    }
  }

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 178, 255, 1) transparent
      transparent transparent;

  }
`;

const FanBuddyIntroPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const onClickStart = () => {
    navigate('/fan-buddy/chat-bot-splash');
  };

  const exit = () => {
    navigate(-1);
  };

  return (
    <>
      <StickyHeader
        title={t('FanBuddyIntroPage.pageTitle')}
        alwaysShowTitle={false}
        showBackButton={false}
        leftContent={<Xmark size={24} className="text-text-main-lv1" onClick={exit} />}
        showTitle={true}
      />
      <AbsoluteCenter style={{ padding: '0 24px', width: '100%' }}>
        <Center flexDirection={'column'}>
          <Title className="text-main-light-1 dark:text-main-dark-1">
            {t('FanBuddyIntroPage.title')}
          </Title>
          <Description className="text-main-light-4 dark:text-main-dark-4">
            {t('FanBuddyIntroPage.description')}
          </Description>
        </Center>
        <Center flexDirection={'column'}>
          <img
            width={'172px'}
            height={'172px'}
            src={'/assets/backgrounds/fan-buddy/Maracas.png'}
            alt={''}
            style={{ paddingTop: '42px' }}
          />
          <RegularSolidButton
            text={t('FanBuddyIntroPage.startButton')}
            style={{
              fontSize: '17px',
              borderRadius: '8px',
              marginTop: '107px',
              padding: '16px 0',
              lineHeight: '20px',
              fontWeight: 500,
              width: '100%'
            }}
            onClicked={onClickStart}
          />
        </Center>
        {/* <AgreementDescription>
        {"시작하기를 누르면 정보저장에 동의합니다"}
      </AgreementDescription> */}
      </AbsoluteCenter>
    </>
  );
};

export default FanBuddyIntroPage;
